import AutoReplenishmentSummary from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishmentSummary/AutoReplenishmentSummary';

export default AutoReplenishmentSummary;
